import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const formVariants = cva(
	'grid',
	{
		variants: {
			variant: {
				default: 'gap-3',
				settings: 'gap-8',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
)

export type FormVariants = VariantProps<typeof formVariants>

export const formItemVariants = cva(
	'',
	{
		variants: {
			variant: {
				simple: 'space-y-1',
				control: 'flex flex-row items-center space-x-2 space-y-0',
			},
		},
		defaultVariants: {
			variant: 'simple',
		},
	},
)

export type FormItemVariants = VariantProps<typeof formItemVariants>

export const formSettingsItemVariants = cva(
	'',
	{
		variants: {
			variant: {
				simple: 'flex max-w-4xl flex-col gap-4 lg:flex-row',
			},
		},
		defaultVariants: {
			variant: 'simple',
		},
	},
)

export type FormSettingsItemVariants = VariantProps<typeof formSettingsItemVariants>
